<template>
    <transition name="fade">
      <div class="back">
        <div
          v-show="open"
          class="contract-modal"
        >
          <transition name="drop-in">
            <div
              v-show="open"
              class="contract-modal-inner"
            >
              <div class="contract-modal-content">
                <div>
                    <div class="contract-modal-header">
                        <h3 class="contract-modal-header-title">
                        {{ openedContract.product }} {{ openedContract.number }}
                        </h3>
                    </div>
                    <div class="contract-modal-body">

                      <p class="contract-modal-body-form-field-label">
                        Страхователь
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.policyholder }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Застрахованные
                      </p>
                      <div v-for="(item) in formData.insureds" v-bind:key="item.id">
                        <div class="contract-modal-body-form-field">{{ item.label }}</div>
                      </div>

                      <p class="contract-modal-body-form-field-label">
                        Срок действия
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.date }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Транспортное средство
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.objects }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Страховая премия
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.insurance_premium }}</div>
                    </div>
                    <button @click="downloadContract" class="download_btn"><img src="../../assets/images/downloadFile_white.svg" alt="">Скачать договор</button>
                </div>
                <button
                  type="button"
                  class="close"
                  @click="close"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { onUnmounted } from "vue";
  import { useToast } from 'vue-toastification'
  import axios from "axios";

  export default {
    props: {
      open: {
        type: Boolean,
        required: true,
      },
      openedContract: {
        type: {
          end_date: String,
          file_path: String,
          id: Number,
          insurance_premium: Number,
          insureds: Array[String],
          number: String,
          objects: Array,
          policyholder: String,
          product: String,
          start_date: String,
        },
        required: true,
      }
    },
    data() {
        return {
            formData: {
              date: null,
              file_path: null,
              id: null,
              insurance_premium: null,
              insureds: [],
              number: null,
              objects: [],
              policyholder: null,
              product: null,
            }
        };
    },
    emits: ['close'],
    setup(_, { emit }) {
      const close = () => {
     
        emit("close");
      };
      const handleKeyup = (event) => {
        if (event.keyCode === 27) {
          close();
        }
      };
  
      // onMounted(() => document.addEventListener("keyup", handleKeyup));
      onUnmounted(() => document.removeEventListener("keyup", handleKeyup));
      return { close };
    },
    watch: {
        open: function () {
          if (this.open) {
            document.documentElement.style.overflow = "hidden";
            return;
          }
          document.documentElement.style.overflow = "auto";
        },
        openedContract: function(){
          if(this.openedContract.id){
            this.formData = {...this.openedContract, insurance_premium: this.openedContract.insurance_premium ? `${this.openedContract.insurance_premium}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : null, objects: `${this.openedContract.objects[0].mark} ${this.openedContract.objects[0].model}, ${this.openedContract.objects[0].plate_number}`, date: `${this.openedContract.start_date}-${this.openedContract.end_date}`, insureds: this.openedContract.insureds.map((item, index) => {
              return{
                label: item
              }
            })}
          }
        }
      },
    methods: {
        handlePasswordConfirmationChange(e){
          this.password_confirmation = e
        },
        async downloadContract(){
          const response = await axios.get(this.openedContract.file_path, {
              responseType: 'blob', 
          })
          const blob = new Blob([response.data])
          const downloadUrl = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = `${this.openedContract.number}.pdf`
          document.body.appendChild(link)
          link.click()
          link.remove()

          window.URL.revokeObjectURL(downloadUrl)
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @mixin mobile {
    @media (min-width: 320px) and (max-width: 425px) {
      @content;
    }
  }
  @mixin tablet {
    @media (min-width: 425px) and (max-width: 768px) {
      @content;
    }
  }
  @mixin tablet-1024 {
    @media (min-width: 768px) and (max-width: 1024px) {
      @content;
    }
  }
  
  *,
  ::before,
  ::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .open {
    background-color: red;
  }
  .forget_password{
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: underline !important;
    margin-top: 10px;
    color: #007BFF;
  }
  .field-error{
    color: red !important;
  }
  .disabledField{
    background: #838484 !important;
  }
  .back{
    position: absolute;
    top: 15px;
    left: 30px;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    font-size: 18px;
    cursor: pointer;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    &::after {
      display: inline-block;
      content: "x";
      margin-top: 15px;
      margin-right: 15px;
    }
  }
  .download_btn{
    width: 100%;
    padding: 9px;
    margin-top: 25px;
    border: none;
    background: #007BFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 8px;
    cursor: pointer;
		position: relative;
		overflow: hidden;
		z-index: 1;
		&::before {
			content: '';
			position: absolute;
			inset: 0;
			z-index: -1;
			background: linear-gradient(90deg, #F5010A 0%, #1521E9 100%);
			opacity: 0;
			transition: opacity 0.3s;
		}

		&:hover::before {
			opacity: 1;
		}
		@media (max-width: 767px) {
			margin-top: 12px;
		}
  }
  .contract-modal{
    &-header{
        &-title{
            font-size: 24px;
            width: 100%;
            margin-top: 30px;

            @include mobile() {
                font-size: 18px;
                margin-top: 15px;
            }

            @include tablet() {
                font-size: 20px;
                margin-top: 20px;
            }
        }
        &-desc{
            text-align: center;
            font-size: 22px;
        }
    }
    &-body{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 4px;
				@media (max-width: 767px) {
					margin-top: 0;
				}
        &-item{
            padding: 15px;
            box-sizing: border-box;
            background: #F7F7F6;
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 9px;
            cursor: pointer;
            &-title{
                text-align: center;
            }
            &-recom{
                font-size: 14px;
                text-align: center;
                background: #37A979;
                color: #fff;
                padding: 10px 20px;
                border-radius: 9px;
            }
            &-desc{
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
            }
            
            img{
                margin: 10px 0;
            }
        }
        &-form{
            // margin-top: 15px;
            width: 100%;
            &-field{
                width: 100%;
                min-height: 55px;
                padding: 15px;
                background: #EFEFEF;
                border: none;
                border-radius: 8px;
                margin-top: 15px;
                display: flex;
                align-items: center;
                white-space: normal;
                word-break: break-word;
                line-height: 100%;
								@media (max-width: 767px) {
									font-size: 14px;
									padding: 10px;
									min-height: 44px;
									margin-top: 4px;
								}
                &-label{
                    color: #373737;
                    font-size: 16px;
                    margin-top: 15px;
										@media (max-width: 767px) {
											font-size: 14px;
											margin-top: 8px;
										}
                }
                &-file{
                    width: 100%;
                    padding: 15px 0;
                    border-radius: 8px;
                    background: #007BFF;
                    position: relative;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 15px;
                    cursor: pointer;
                    input{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        opacity: 0;
                    }
                }
            }
            button{
                width: 100%;
                padding: 15px 0;
                border-radius: 8px;
                background: #007BFF;
                margin-top: 15px;
                color: #fff;
                border: none;
                cursor: pointer;
            }
        }
    }
    }
  .contract-modal {
    // overflow: hidden;
    // overflow-y: scroll;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 5%;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1000 !important;
    // background: rgba(0, 0, 0, 0.1);
    &-inner {
      width: clamp(250px, 60%, 500px);
      margin: 10px auto;
      filter: drop-shadow(0px 4px 30px rgba(0, 0, 0, 0.13));
      z-index: 10000000 !important;
    }
    &-content {
      position: relative;
      background-color: #fff;
      background-clip: padding-box;
      border-radius: 15px;
      padding: 25px;

      @include mobile() {
        padding: 16px;
      }

      @include tablet() {
        padding: 20px;
      }
    }
    @include mobile() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
    @include tablet() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
    @include tablet-1024() {
      &-inner {
        width: 70%;
        margin: 0 auto;
      }
    }
  }
  
  
  //animation --->
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .drop-in-enter-active,
  .drop-in-leave-active {
    transition: all 0.3s ease-out;
  }
  .drop-in-enter-from,
  .drop-in-leave-to {
    opacity: 0;
    transform: translateY(-50px);
  }
  </style>
  